export const syncMenu = {
	title: "Menú de Delivery ({{externalStoreType}})",
	description:
		"Seleccione en la lista de Zig el producto a ser asociado con el elemento de {{externalStoreType}}. Los elementos se volverán únicos",
	menuNameExternalType: "Menú de Delivery ({{externalStoreType}})",
	transferProducts: {
		warning:
			"{{amount}} productos no fueron sincronizados. ¿Le gustaría importarlos al menú de Delivery?",
		description:
			"Seleccione los elementos que le gustaría importar, o finalice para seguir.",
		amountItemsSelected: "<strong>{{amount}}</strong> elementos seleccionados",
		completeBtn: "Completar sin importar",
		importItemsBtn: "Importar elementos",
	},
	bindProduct: {
		searchPlaceholder: "Busque otro producto para sincronizar",
		allProducts: "Todos los productos",
		notProductFound: "Ningún producto encontrado",
		errorProductFound: "Ocurrió un error al buscar los productos",
		similarity: {
			title: "Ningún producto similar encontrado",
			description:
				"Haga una búsqueda en la barra de búsqueda arriba, o pase al siguiente producto.<br/>Podrá importar los productos sin similitud al final de la sincronización.",
		},
		saveLater: "Guardar y continuar más tarde",
		undo: "Deshacer acción anterior",
		completeSync: "Completar sincronización",
		skipAll: "Saltar todos",
		skuInfo: {
			title: "El SKU de este producto será reemplazado",
			description:
				"El SKU de ZIG (producto seleccionado al lado) se sobrepondrá en ambos menús. Esto es lo que permitirá una gestión centralizada.",
		},
		undoModal: {
			title: "¿Deshacer sincronización?",
			description:
				"Al confirmar, volveremos al producto anterior y la sincronización será deshecha.",
			okText: "Quiero deshacer",
			cancelText: "Cancelar",
		},
	},
	productCard: {
		descriptionLabel: "Descripción",
		optionsLabel: "Opcionales",
		syncedSectionsLabel: "Secciones sincronizadas",
		syncAriaLabel: "Sincronizar",
		active: "Activo",
		inactive: "Inactivo",
	},
	transferProductSuccess: {
		title: "Integración completada",
		description:
			"¡Su integración fue completada y sus productos fueron sincronizados con éxito!",
		button: "Ver productos y menús",
	},
	syncMenuSuccess: {
		title: "Integración completada",
		description:
			"¡Su integración fue completada y sus productos fueron sincronizados con éxito!",
		button: "Ver productos y menús",
		continue: "Ver productos no importados",
	},
	errorContent: {
		title: "No fue posible importar los productos",
		description:
			"Algo inesperado sucedió y no pudimos completar la importación de los productos. Complete su integración y finalice su menú más tarde.",
		completeBtn: "Completar sincronización sin importar",
		retryBtn: "Intentar importar nuevamente",
	},
	onboarding: {
		step1: {
			title: "Mostraremos un producto a la vez",
			description:
				"Cada producto importado será mostrado al lado de sugerencias equivalentes en el catálogo de productos de ZIG. Usted seleccionará el producto ideal para unificar.",
		},
		step2: {
			title: "Un único SKU",
			description:
				"Al seleccionar el producto, el SKU de ZIG prevalecerá y podrá hacer una gestión centralizada en nuestro dashboard.",
		},
		step3: {
			title: "Importe lo que aún no esté en Zig",
			description:
				"Cuando termine de sincronizar los elementos equivalentes, podrá importar los productos que no fueron identificados en el catálogo de ZIG. ¡Así, tendrá todos sus productos en un solo lugar!",
		},
		skipBtn: "Saltar",
		submitBtn: "Comenzar sincronización",
	},
	completeSyncModal: {
		title: "Completar sincronización",
		text:
			"¡Genial! ¡Sincronizó todos los productos!<br/>¿Desea deshacer la última sincronización o podemos completar esta etapa?",
		undoBtn: "Deshacer la última sincronización",
		completeBtn: "Completar etapa",
	},
};
